module.exports = __webpack_public_path__ + "97ab5c1e4164372f4c4f1fa6733743e6.fbx";